import { render } from "./ChildDevelopmentClass.vue?vue&type=template&id=4bbf8526&ts=true"
import script from "./ChildDevelopmentClass.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentClass.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__